import React, { useState } from 'react';
import ProposalsView from './ProposalsView';
import QuestionsView from './QuestionsView';
import '../styles/ActionInboxPage.css';

/**
 * The proposals and questions workspace — where a queue row opens to.
 *
 * It called itself the Action Inbox, and behind it sat a second 60-second poll
 * counting proposals, invitations and follow requests into a badge that appeared
 * nowhere. Two things claiming to be the inbox is how the real one stayed invisible
 * inside a settings window for months; the counting half is gone, and the queue lane
 * carries it now. What remains is the workspace itself, which is a real place to
 * review a proposal rather than a list of what is waiting.
 */
const ActionInboxPage = ({ initialView = 'proposals' }) => {
  const [activeView, setActiveView] = useState(initialView);

  return (
    <div className="aip-shell">
      <div className="aip-topnav">
        <span className="aip-topnav-label">Review</span>
        <button
          className={`btn aip-nav-btn${activeView === 'proposals' ? ' active' : ''}`}
          onClick={() => setActiveView('proposals')}
        >
          Proposals
        </button>
        <button
          className={`btn aip-nav-btn${activeView === 'questions' ? ' active' : ''}`}
          onClick={() => setActiveView('questions')}
        >
          Questions
        </button>
      </div>

      <div className="aip-body">
        {activeView === 'proposals' && <ProposalsView />}
        {activeView === 'questions' && <QuestionsView />}
      </div>
    </div>
  );
};

export default ActionInboxPage;
